export default __webpack_public_path__ + "static/media/non-organic-free.885ed4c8.png";